import { useEffect,useState } from "react";
import { RES_MENU_API } from "./constants";


const useRestaurantMenu=(resId)=>{
     
    const [resMenu,setResMenu]=useState({});
    useEffect(()=>{
        fetchMenu()
    },[])

//     //
const fetchMenu= async ()=>{
     const data=await fetch(RES_MENU_API+resId).catch(
        (err)=>{
            console.log(err.message);
        }
     )
     //console.log("data= "+data);
     const json =await data?.json();
    //console.log(json);
    setResMenu(json)
    console.log(json)
   // console.log("resmenu== \n",resMenu)


}


    return resMenu;
}
export default useRestaurantMenu;